import { FirebaseDocChangeType } from 'firebase/index'
import { BasketType } from 'types/basket'
import { Action, Dispatch } from 'redux'
import { fetchBasketsAction } from 'reducks/basket/actions'

const mergeListeningBaskets = (
  changes: FirebaseDocChangeType[],
  currentBaskets: BasketType[],
  dispatch: Dispatch<Action>
): void => {
  const baskets: BasketType[] = currentBaskets
  for (let i = 0; i < changes.length; i = (i + 1) | 0) {
    const change = changes[i]
    const data = change.doc.data() as BasketType
    // 同じ注文番号がすでに存在する場合は追加しない
    if (baskets.some((basket) => basket.basket_number === data.basket_number)) continue
    baskets.push(data)
  }
  if (baskets.length > 0) {
    dispatch(fetchBasketsAction(baskets))
  }
}

export default mergeListeningBaskets
